import { html } from "lit";
import { renderStandardPictureElement } from "../../../../utils";

export const newsroomTeaserData = {
    tag: "pressemitteilung",
    headline: "Lorem ipsum dolor sit amet",
    buttonText: "Mehr erfahren",
};

export const TeaserNewsroomTemplate = (args) => html`
    <ux-iws-link-wrapper class="ux-iws-teaser-newsroom">
        <div class="ux-iws-teaser-newsroom__img-container">
            ${renderStandardPictureElement({
                width: 1600,
                height: 900,
            })}
        </div>
        <div class="ux-iws-teaser-newsroom__content">
            <div class="ux-iws-teaser-newsroom__info">
                <div class="ux-iws-teaser-newsroom__tag-container">
                    <ux-tag disabled>${newsroomTeaserData.tag}</ux-tag>
                    ${args.variant === "with en tag"
                        ? html` <ux-tag disabled>
                              <ux-icon name="globe-small"></ux-icon> EN
                          </ux-tag>`
                        : html``}
                </div>
                <ux-text-lines-limit text-lines="2">
                    <h4 class="ux-text-headline ux-text-headline--small">
                        Lorem ipsum dolor sit amet
                    </h4>
                </ux-text-lines-limit>
            </div>
            <div class="ux-iws-teaser-newsroom__body">
                <ux-text-lines-limit text-lines="3">
                    <p
                        class="ux-text-normal ux-text-normal--light-gray ux-u-margin-vertical-0"
                    >
                        Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                        sed diam nonumy eirmod tempor invidunt ut labore et
                        dolore magna aliquyam erat, sed diam voluptua. At vero
                        eos et accusam et justo duo dolores et ea rebum. Stet
                        clita kasd gubergren, no sea takimata sanctus est Lorem
                        ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                        consetetur sadipscing elitr, sed diam nonumy eirmod
                        tempor invidunt ut labore et dolore magna aliquyam erat,
                        sed diam voluptua. At vero eos et accusam et justo duo
                        dolores et ea rebum. Stet clita kasd gubergren, no sea
                        takimata sanctus est Lorem ipsum dolor sit amet. Lorem
                        ipsum dolor sit amet, consetetur sadipscing elitr, sed
                        diam nonumy eirmod tempor invidunt ut labore et dolore
                        magna aliquyam erat, sed diam voluptua. At vero eos et
                        accusam et justo duo dolores et ea rebum. Stet clita
                        kasd gubergren, no sea takimata sanctus est Lorem ipsum
                        dolor sit amet. Duis autem vel eum iriure dolor in
                        hendrerit in vulputate velit esse molestie consequat,
                        vel illum dolore eu feugiat nulla facilisis at vero eros
                        et accumsan et iusto odio dignissim qui blandit praesent
                        luptatum zzril delenit augue duis dolore te feugait
                        nulla facilisi. Lorem ipsum dolor sit amet, consectetuer
                        adipiscing elit, sed diam nonummy nibh euismod tincidunt
                        ut laoreet dolore magna aliquam erat volutpat. Ut wisi
                        enim ad minim veniam, quis nostrud exerci tation
                        ullamcorper suscipit lobortis nisl ut aliquip ex ea
                        commodo consequat. Duis autem vel eum iriure dolor in
                        hendrerit in vulputate velit esse molestie consequat,
                        vel illum dolore eu feugiat nulla facilisis at vero eros
                        et accumsan et iusto odio dignissim qui blandit praesent
                        luptatum zzril delenit augue duis dolore te feugait
                        nulla facilisi. Nam liber tempor cum soluta nobis
                        eleifend option congue nihil imperdiet doming id quod
                        mazim placerat facer possim assum. Lorem ipsum dolor sit
                        amet, consectetuer adipiscing elit, sed diam nonummy
                        nibh euismod tincidunt ut laoreet dolore magna aliquam
                        erat volutpat. Ut wisi enim ad minim veniam, quis
                        nostrud exerci tation ullamcorper suscipit lobortis nisl
                        ut aliquip ex ea commodo consequat. Duis autem vel eum
                        iriure dolor in hendrerit in vulputate velit esse
                        molestie consequat, vel illum dolore eu feugiat nulla
                        facilisis. At vero eos et accusam et justo duo dolores
                        et ea rebum. Stet clita kasd gubergren, no sea takimata
                        sanctus est Lorem ipsum dolor sit amet. Lorem ipsum
                        dolor sit amet, consetetur
                    </p>
                </ux-text-lines-limit>
                <div class="ux-iws-teaser-newsroom__cta-container">
                    <a
                        href="#"
                        class="ux-button ux-button--icon-only"
                        aria-label="Lorem Ipsum"
                        role="button"
                    >
                        <ux-icon name="chevron-right"></ux-icon>
                    </a>
                    <a href="#" class="ux-button">
                        ${newsroomTeaserData.buttonText}
                    </a>
                </div>
            </div>
        </div>
    </ux-iws-link-wrapper>
`;
